import TooltipTab from './ToolTipTab';

export default TooltipTab;



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/subComponents/ToolTipTab/index.jsx